/**
 * Created by mgoria on 12/03/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LambdaParamsCompatibilityException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let LambdaParamsCompatibilityException = exports.LambdaParamsCompatibilityException = function (_Exception) {
  _inherits(LambdaParamsCompatibilityException, _Exception);

  /**
   * @param {Object} params
   * @param {String} message
   */
  function LambdaParamsCompatibilityException(params) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, LambdaParamsCompatibilityException);

    return _possibleConstructorReturn(this, (LambdaParamsCompatibilityException.__proto__ || Object.getPrototypeOf(LambdaParamsCompatibilityException)).call(this, `Lambda parameters "${JSON.stringify(params)}" are incompatible. ${message}`));
  }

  return LambdaParamsCompatibilityException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/LambdaParamsCompatibilityException.js
// module id = 417
// module chunks = 0